import * as React from 'react';

/**
 * Makes a stable reference of the `trpc` prop
 */ function useHookResult(value) {
    const path = value.path.join('.');
    return React.useMemo(()=>({
            path
        }), [
        path
    ]);
}

export { useHookResult };
